




























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import logger from "@/configs/logger";
import { Action, State } from "vuex-class";
import { User } from "@/types";
import featureConfig from "@/helpers/featureConfigs";
import * as api from "@/lib/api";

@Component
export default class UpdateAgent extends Vue {
  @Prop({ required: true }) agent!: any;
  @Prop() toggleManageAgentDialog!: Function;
  @Action("updateAgent") updateAgent!: Function;
  @State("user") user!: User;

  agentUpdates: any = {};

  @Watch("agent")
  onAgentChange() {
    this.agentUpdates = {};
  }

  get groups() {
    if (this.user.roles.includes("admin")) {
      return featureConfig.getGroupTypes();
    }
    return featureConfig
      .getGroups(this.user.groups)
      .filter(group => !!group.groupSupervising)
      .map(group => group.groupSupervising);
  }

  getCloserPriority(agent: any): string {
    return agent.closer_priority || "0";
  }

  getRolesFromGroups(groups: Array<string>): Array<string> {
    const roles = new Set<string>();
    featureConfig.getGroups(groups).forEach(group => {
      if (group.groupType) {
        roles.add(group.groupType);
      }
    });
    return Array.from(roles);
  }

  submitAgentUpdate(notify = false) {
    if (Array.isArray(this.agentUpdates.groups)) {
      this.agentUpdates.roles = this.getRolesFromGroups(
        this.agentUpdates.groups
      );
    }
    this.updateAgent({
      data: this.agentUpdates,
      userId: this.agent.id,
      notify
    });
  }

  handleInputChange(key: string, val: string) {
    if (key === "auto_accept") {
      this.agentUpdates[key] = val === "true";
    } else {
      this.agentUpdates[key] = val;
    }
  }

  async handleDeleteAgent() {
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this user?"
      );
      if (confirmed) {
        logger("log", "deleting user:", this.agent);
        await api.adminDeleteAgent(this.agent.id);
        this.$toasted.success("Agent successfully deleted").goAway(2000);
        this.toggleManageAgentDialog(false);
      }
    } catch (err) {
      logger("error", "delete user error:", err);
      this.$toasted.error("Delete user error").goAway(2000);
    }
  }

  async handleDisableAgent() {
    try {
      const confirmed = window.confirm(
        "Are you sure you want to disable this user?"
      );
      if (confirmed) {
        logger("log", "disabling user:", this.agent);
        await api.adminDisableAgent(this.agent.id, true);
        this.$toasted.success("Agent successfully disabled").goAway(2000);
        this.toggleManageAgentDialog(false);
      }
    } catch (err) {
      logger("error", "disable user error:", err);
      this.$toasted.error("Delete user error").goAway(2000);
    }
  }

  async handleReactivateAgent() {
    try {
      const confirmed = window.confirm(
        "Are you sure you want to reactivate this user?"
      );
      if (confirmed) {
        logger("log", "reactivating user:", this.agent);
        await api.adminDisableAgent(this.agent.id, false);
        this.$toasted.success("Agent successfully reactivated").goAway(2000);
        this.toggleManageAgentDialog(false);
      }
    } catch (err) {
      logger("error", "reactivate user error:", err);
      this.$toasted.error("Delete user error").goAway(2000);
    }
  }
}
